export const getSavedActiveProjects = (data: $TSFixMe) =>
  data.map((project: $TSFixMe) => project.id)

export const getSavedActiveProjectsString = (data: $TSFixMe) =>
  data.map((project: $TSFixMe) => project.id).join(',')
